import { withRouter, Redirect } from 'react-router-dom'
import React from 'react'
import { connect } from 'react-redux'
import { selectWorkcenter } from '../actions/AuthActions'

const mapStateToProps = state => ({
  authenticated: state.auth.session.token !== false,
  invalid: state.auth.invalid,
  pendingToken: state.auth.pendingToken,
  workcenters: state.auth.workcenters
})

const mapDispatchToProps = dispatch => ({
  selectWorkcenterAction: (id) => dispatch(selectWorkcenter(id))
})

function WorkcenterSelectComponent({ authenticated, invalid, pendingToken, workcenters, selectWorkcenterAction }) {
  if (!pendingToken) return <Redirect to={authenticated ? '/' : '/login'} />

  return (
    <div className="login-stage">
      <div className="login-card wc-select-card">
        <h3>Wybierz stanowisko</h3>
        <div className="wc-select">
          {(workcenters || []).map(wc => (
            <button
              key={wc.id}
              type="button"
              className="wc-select__tile"
              onClick={() => selectWorkcenterAction(wc.id)}
            >
              {wc.name}
            </button>
          ))}
        </div>
        {invalid && <p className="form-error">Nie udało się wybrać stanowiska. Spróbuj ponownie.</p>}
      </div>
    </div>
  )
}

const WorkcenterSelect = connect(mapStateToProps, mapDispatchToProps)(WorkcenterSelectComponent)
export default withRouter(WorkcenterSelect)
